import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from '@angular/router';

import { Observable } from 'rxjs';
import { UserCooperativeService } from '../../user/user-cooperative.service';
import { CooperativeModel } from '../../models/cooperative.model';

@Injectable({ providedIn: 'root' })
export class AuthCooperativeGuard implements CanActivate {
  constructor(
    private userCooperativeService: UserCooperativeService,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | Observable<boolean> | Promise<boolean> {
    if (
      !this.userCooperativeService.isLogged() ||
      this.userCooperativeService.isTokenExpired() ||
      !this.userCooperativeService.hasRole('ROLE_COOPERATIVE')
    ) {
      this.router.navigate(['/auth-cooperative/login'], {
        queryParams: { returnUrl: state.url },
      });
      return false;
    }

    return true;
  }
}
